import React, { FC, useState, useEffect } from 'react';

import { Button, Grid } from '@mui/material';

import { Save } from '@mui/icons-material';

import ErrorMessage from '../../sharedModules/layout/ErrorMessage';
import TextInput from '../../sharedModules/form/components/TextInput';

import { PhotoProposal } from '../model';

import axios from '../../sharedModules/utils/axios.utils';

interface PhotoProposalTitleEditFieldProps {
  photoProposal: PhotoProposal;
  fetchPhotoProposal: () => void;
}

const PhotoProposalTitleEditField: FC<PhotoProposalTitleEditFieldProps> = ({ photoProposal, fetchPhotoProposal }) => {
  const [errorMessage, setErrorMessage] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);
  const [localTitle, setLocalTitle] = useState<string>('');

  useEffect(() => {
    if (photoProposal?.title) setLocalTitle(photoProposal?.title);
  }, [photoProposal]);

  const updatePhotoProposal = async () => {
    setLoading(true);
    try {
      await axios.put(`/photo_proposals/photo_proposals/${photoProposal?.id}`, {
        photo_page_proposal: { title: localTitle },
      });

      fetchPhotoProposal();
      setErrorMessage('');
    } catch (error) {
      setErrorMessage('Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Grid container spacing={2} style={{ alignItems: 'center' }}>
      <Grid item xs={12}>
        <ErrorMessage message={errorMessage} />
      </Grid>
      <Grid item xs={12} md={9}>
        <TextInput
          value={localTitle}
          valueChanged={(value) => setLocalTitle(value)}
          label="Proposal Title"
          rows={5}
          shrinkLabel={true}
        />
      </Grid>
      <Grid item xs={6} md={1}>
        <Button
          variant="contained"
          size="small"
          onClick={updatePhotoProposal}
          disabled={localTitle === photoProposal?.title || loading}
        >
          <Save />
        </Button>
      </Grid>
    </Grid>
  );
};

export default PhotoProposalTitleEditField;
